<ciciam-frame-front>
  <div class="w-full md:max-w-md md:mt-0 xl:p-0 md:ml-auto">
    <div class="py-6 md:p-6">
      <h2 class="text-xl text-green-800 font-semibold">
        {{ 'Forgot Username' | translate }}
      </h2>

      <div class="py-2"></div>

      <ng-container *ngIf="userInfo$ | async as userInfo; else noUserInfo">
        <div class="relative rounded-3xl border border-gray-300 p-4">
          <p
            class="text-sm font-light text-gray-800 dark:text-white text-justify"
          >
            <span>{{ 'Your username will be sent to' | translate }}</span>
            <span *ngIf="userInfo.phone" class="font-medium text-black">{{
              'Phone number' | translate
            }}</span>
            <span
              *ngIf="!userInfo.phone && userInfo.email"
              class="font-medium text-black"
              >{{ 'Email Address' | translate }}</span
            >
          </p>

          <p *ngIf="userInfo.phone" class="text-sm font-medium text-black">
            {{ userInfo.phone }}
          </p>

          <p
            *ngIf="!userInfo.phone && userInfo.email"
            class="text-sm font-medium text-black"
          >
            {{ userInfo.email }}
          </p>
        </div>
      </ng-container>

      <ng-template #noUserInfo>
        <div class="relative rounded-3xl border border-gray-300 p-4">
          <p
            class="text-sm font-light text-gray-800 dark:text-white text-justify"
          >
            {{ 'No result found.' | translate }}
          </p>
        </div>
      </ng-template>

      <div class="text-center mt-4">
        <div class="">
          <p
            class="my-4 text-sm font-light text-gray-800 dark:text-white text-center"
            [translate]="
              'If you are unable to provide the above information, please call {{contact}} for follow-up.'
            "
            [translateParams]="{ contact: supportNumber }"
          ></p>

          <p
            class="text-sm font-light text-gray-800 dark:text-gray-400 text-center"
          >
            <a
              (click)="goToLogin($event)"
              class="text-notus-primary-700 hover:underline dark:text-primary-600 cursor-pointer underline underline-offset-4 text-xs"
              >{{ 'Back to login' | translate }}</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</ciciam-frame-front>
